/** Replaces the four @fortawesome packages that were pulled in for one chevron. */
export default function BackButton({ className, onClick }) {
  return (
    <button type="button" className={`back-button ${className}`} onClick={onClick} aria-label="Start over">
      <svg width="24" height="32" viewBox="0 0 256 512" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.6 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.4-9.4-9.4-24.6 0-33.9z" />
      </svg>
    </button>
  )
}
